import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountDeletionFormComponent } from './account-deletion-form/account-deletion-form.component';
import {
    AlertModule,
    ButtonModule,
    InputModule,
    LinkModule,
    ModalsModule,
    SosAccountStoreModule,
    SosAuthorizationStoreModule,
} from '@serviceos-ng/core';
import { AccountDeletionModalComponent } from './account-deletion-modal/account-deletion-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [AccountDeletionFormComponent, AccountDeletionModalComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ModalsModule,
        LinkModule,
        InputModule,
        SosAuthorizationStoreModule,
        SosAccountStoreModule,
        ButtonModule,
        AlertModule,
    ],
    exports: [AccountDeletionFormComponent, AccountDeletionModalComponent],
})
export class AccountManagementModule {}
